import _ from "lodash";
import React from "react";
import { useSelector } from "react-redux";
import AplSettingsSelector from "../../../redux/helpers/AplSettingsSelector";
import { useAppDispatch } from "../../../redux/hooks";
import {
    addWorkorderManagementBobRedux,
    changeWorkorderManagementBobPriorityRedux,
    deleteWorkorderManagementBobRedux,
    onSetSelectedBobs,
    setOrderBobAddingRedux
} from "../../../redux/slices/workorderManagement.feature";
import { DtGridPropsOptions2 } from "../../../types/dtGridPropsOptions2";
import { IRootState } from "../../../types/redux/IRootStore";
import { DtGrid2 } from "../../common/DtGrid2";
import { getWorkorderManagementBobPaneColumns } from "./WorkorderManagementBobPaneColumns";
import { translateColumns, translateString } from "../../../translations/gridTranslationHelper";
import { useTranslation } from "react-i18next";
import { WorkorderManagementBob } from "../../../types/workorderManagementBob";

export default function WorkorderManagementBobPane() {
    const { t } = useTranslation();
    const workorderManagementRedux = useSelector((state: IRootState) => state.workorderManagement);
    const dispatch = useAppDispatch();
    const aplSettings = AplSettingsSelector();

    const setSelected = (x: any) => {
        dispatch(onSetSelectedBobs(x));
    };

    const saveBatchFetchCurrentState = (workorderBob: WorkorderManagementBob) => {
        dispatch(onSetSelectedBobs([]));
    };

    const deleteBatchFetchCurrentState = (workorderBatch: WorkorderManagementBob) =>
        dispatch(deleteWorkorderManagementBobRedux(workorderBatch) as any);

    const changePriorityFetchCurrentState = async (workorderBob: WorkorderManagementBob, offset: number) => {
        dispatch(changeWorkorderManagementBobPriorityRedux({ bob: workorderManagementRedux.orderBobsSelected[0], offset: offset }) as any);
    };
    const dtGridOptns: DtGridPropsOptions2 = {
        data: workorderManagementRedux.orderBobsData,
        columnData: translateColumns(
            getWorkorderManagementBobPaneColumns(
                aplSettings.culture,
                workorderManagementRedux.orderBobsSelected,
                saveBatchFetchCurrentState,
                deleteBatchFetchCurrentState,
                changePriorityFetchCurrentState
            ),
            aplSettings.culture
        ),
        defaultSort: {
            field: ["priority"],
            direction: ["asc"]
        },
        selectType: "single",
        colouring: false,
        headerFilters: false,
        setSelectedItems: setSelected,
        tableName: "tblWorkorderBobs",
        tableClass: "table-workorder-bobs",
        paging: true,
        showSpinner: false,
        rowId: "woBobId",
        pageLength: 16,
        loading: workorderManagementRedux.orderBobsDataLoading,
        bulk: false,
        selectedItems: workorderManagementRedux.orderBobsSelected,
        filters: {},
        setFilters: _.noop,
        refreshSelectedOnDataChange: true,
        page: 1,
        setPage: _.noop
    };

    return (
        <React.Fragment>
            <div className="container mw-100 p-2 pt-0 mt-1">
                <div className="row ml-1 mr-1">
                    <div className="col-sm-12">
                        <DtGrid2 options={dtGridOptns} />
                    </div>
                </div>
                <div className="row ml-1 mr-1 buttoms-shift-up">
                    <div className="col-sm-9">&nbsp;</div>
                    <div className="col-sm-3 mt-1">
                        <div className="input-group">
                            <input
                                type="number"
                                className="form-control"
                                placeholder={translateString("batch", aplSettings.culture)}
                                onChange={e => {
                                    dispatch(setOrderBobAddingRedux(e.currentTarget.valueAsNumber));
                                }}
                                value={workorderManagementRedux.orderBobAdding ?? ""}
                            ></input>
                            <div className="input-group-append">
                                <input
                                    type="button"
                                    className="btn btn-primary float-right ml-1 mr-1"
                                    onClick={() => {
                                        if (workorderManagementRedux.orderData && workorderManagementRedux.orderBobAdding) {
                                            let adding = {
                                                workorderId: workorderManagementRedux.orderData.workorderId,
                                                batch: workorderManagementRedux.orderBobAdding,
                                                siteId: workorderManagementRedux.orderData.siteId
                                            };
                                            dispatch(addWorkorderManagementBobRedux(adding) as any);
                                        }

                                        console.log(`${new Date().toISOString()} - ${workorderManagementRedux.orderBobAdding}`);
                                    }}
                                    value={t("main.insert")!}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
